/* MUI */
import { Box } from '@mui/material';
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';

/* Shared */
import { PartnerAppModal } from 'application/Shared/Modals';

/* React */
import React, { useState } from 'react';

/**
 * There are props for three different components in ApplicationNameLinkCell: Application, ApplicationName, and ApplicationCategoryAndSubCategory
 * For ApplicationName we have:
 * @param nameClassname to be applied to the name string. If link is set, then it will be overwritten in the component itself to be
 * "link underline bold".
 * @param nameLines to tell TextTruncate to how many lines it will be truncated, if nothing is set, it defaults to 1 line.
 * @param nameNoTruncate tells it to show the whole text, don't use TextTruncate.
 * @param scrollFrom and
 * @param scrollTo work together in printed pdf to reference where to jump back and forth in a report when you click in the app name.
 * For ApplicationCategoryAndSubCategory we have
 * @param categoryClassname to be applied to the name string. If link is set, then it will be overwritten in the component itself to be
 * "link underline bold".
 * @param categoryLines to tell TextTruncate to how many lines it will be truncated, if nothing is set, it defaults to 1 line.
 * @param categorySize not set it will be small, font[0], if regular font size is required, it should be set as size="normal".
 * @param categoryNoTruncate tells it to show the whole text, don't use TextTruncate.
 *
 * Also included
 * @param data the data for which to open the modal.
 * @param withCategory to show the category, default is false.
 * @returns JSX of the icon, clickable app name (that could link to the app's page), and, included, the app's category and subCategory.
 */
export const ApplicationNamePartnerAppModalCell = ({
    categoryClassname,
    categoryLines,
    categoryNoTruncate,
    categorySize, // Will be size small is size="normal" is not given
    data,
    key,
    nameClassname,
    nameLines, // If not provided it will default to 1 of truncation
    nameNoTruncate,
    onClose,
    scrollFrom,
    scrollTo,
    withCategory
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        setIsModalOpen(true);
    };

    const closingModal = (isChanged) => {
        if (onClose) {
            onClose(isChanged || false);
        }
        setIsModalOpen(false);
    };

    return (
        <Box>
            {isModalOpen && (
                <PartnerAppModal
                    open={isModalOpen}
                    data={data}
                    onCloseModal={(isChanged) => closingModal(isChanged)}
                />
            )}
            <Box key={key}>
                <ApplicationNameLinkCell
                    categoryClassname={categoryClassname}
                    categoryLines={categoryLines}
                    categoryNoTruncate={categoryNoTruncate}
                    categorySize={categorySize}
                    nameClassname={nameClassname}
                    nameLines={nameLines}
                    nameNoTruncate={nameNoTruncate}
                    onNameClick={onClick}
                    scrollFrom={scrollFrom}
                    scrollTo={scrollTo}
                    withCategory={withCategory}
                />
            </Box>
        </Box>
    );
};
